import React from "react";
import { DatePicker, DateTimePicker } from "@material-ui/pickers";
import { InputAdornment, IconButton } from "@material-ui/core";
import { Clear as ClearIcon } from "@material-ui/icons";
import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";

// prop types
interface DateSelectProps {
    disablePast?: boolean,
    helperText?: string,
    initialFocusedDate?: string,
    label: string,
    value?: string,
    variant?: "filled" | "outlined" | "standard",
    withTime?: boolean,
    onChange: (m?: MaterialUiPickersDate) => void,
}

// default date picker
const DateSelect = ({ disablePast, helperText, initialFocusedDate, label, value, variant, withTime, onChange }: DateSelectProps) => {
    const Picker = withTime ? DateTimePicker : DatePicker;
    return (
        <Picker
            ampm={false}
            autoOk
            disablePast={disablePast}
            format={withTime ? "DD.MM.YYYY HH:mm" : "DD.MM.YYYY"}
            fullWidth
            helperText={helperText}
            initialFocusedDate={initialFocusedDate}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton onClick={(e) => { e.stopPropagation(); onChange(undefined); }}>
                            <ClearIcon />
                        </IconButton>
                    </InputAdornment>
                ),
            }}
            inputVariant={variant}
            label={label}
            minutesStep={15}
            value={value || null}
            variant="inline"
            onChange={onChange}
        />
    );
};

export default DateSelect;
